import BaseEnumType from "../../common/base-enum-type";

const PatScoreType = Object.freeze({
    SCORED: new BaseEnumType("Y", "SCORED"),
    SAFETY: new BaseEnumType("S", "SAFETY"),
    NONE: new BaseEnumType("N", "NONE")
});

export default PatScoreType;
